import React, {useContext, useState} from 'react';
import cl from './UploadModal.module.css'
import parent from '../MyModal/MyModal.module.css'
import clear from '../../../Assets/icons/clear.svg'
import warning from '../../../Assets/icons/error_outline.svg';
import Columns from "../../Columns";
import TupoList from "../../TupoList";
import delete_icon from '../../../Assets/icons/delete.svg'
import error from '../../../Assets/icons/error.svg'
import {useNavigate} from "react-router-dom";
import Service from "../../../API/Service";
import {AuthContext} from "../../../context";


const UploadModal = ({visible, setVisible, list, entity}) => {
    const rootClasses = [parent.myModal]

    const navigate = useNavigate();
    const {uploadState, setUploadState} = useContext(AuthContext)

    const [selectedFile, setSelectedFile] = useState(null);
    const [dragActive, setDragActive] = useState(false);
    const [isInvalidFile, setIsInvalidFile] = useState(false);

    const list1 = ["Adfgf", "Dfghgj", "Bgdushd", "Naghrmyu", "Shawn"]
    const list2 = ["dsvnjsdvn", "jdvsnvj", "dsvnjsdvn", "jdvsnvj", "jdvsnvj", ]

    const invalidFileFormat = () =>{
        setIsInvalidFile(true);
        setTimeout(()=>{
            setIsInvalidFile(false)
        }, 5000)

    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.name.endsWith('.xlsx')) {
            setSelectedFile(file);
        } else {
           invalidFileFormat()
        }
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        setDragActive(true);
    };

    const handleDragLeave = () => {
        setDragActive(false);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        setDragActive(false);
        const file = event.dataTransfer.files[0];
        if (file && file.name.endsWith('.xlsx')) {
            setSelectedFile(file);
        } else {
            invalidFileFormat()
        }
    };

    const handleRemoveFile = () => {
        setSelectedFile(null);
    };

    if (visible){
        rootClasses.push(parent.active);
    }

    const uploadFile = async () => {
        try {
            const response = await Service.uploadUsers(entity, selectedFile);

            if (response.status >= 200 && response.status < 300) {
                setUploadState('true');
                setVisible(false);
                navigate(`/${entity}`);
                setTimeout(()=>{
                    setUploadState('')
                }, 5000)
            } else {
                setVisible(false);
                setUploadState('false');
                setTimeout(()=>{
                    setUploadState('')
                }, 5000)
                // throw new Error("Ошибка при загрузке студентов!"); // Явно вызываем ошибку
            }
            navigate(`/${entity}`);
        } catch (error){
            setVisible(false);
            setUploadState('false');
            setTimeout(()=>{
                setUploadState('')
            }, 5000)
            // alert("Ошибка при загрузке студентов!");
        }

    }

    return (
        <div className={rootClasses.join(' ')} onClick={() => setVisible(false)}>
            <div className={cl.myModalContent} onClick={(e) => {
                e.stopPropagation();
                handleRemoveFile();
            }}>
                <div className={cl.upperPart}>
                    <div className={cl.header}>
                        <p>Upload list</p>
                        <img
                            src={clear}
                            alt={"X"}
                            onClick={() => {
                                setVisible(false);
                                handleRemoveFile();
                            }}
                        />
                    </div>
                    <div className={cl.template}>
                        <p>Download the template to ease your process</p>
                        <button onClick={() => Service.downloadTemplate()}>Template File</button>
                    </div>
                </div>
                <div className={cl.requirements}>
                    <p>Your list must contain this columns:</p>
                    <div className={cl.columnsList}>
                        {list.map((value, index) => (
                            <Columns key={index} value={value}/>
                        ))}
                    </div>
                </div>
                <div className={cl.example}>
                    <p>Example of content in your list</p>
                    <div className={cl.table}>
                        <TupoList
                            head={"Name"}
                            list={list1}
                        />
                        <TupoList
                            head={"Surname"}
                            list={list1}
                        />
                        <TupoList
                            isRepeat={true}
                            head={"Date of birth"}
                            listR={"01.01.1999"}
                        />
                        <TupoList
                            head={"Department"}
                            list={list2}
                        />
                        <TupoList
                            isRepeat={true}
                            head={"Email"}
                            listR={"fdsgd@mail.com"}
                        />
                        <TupoList
                            isRepeat={true}
                            head={"Phone number"}
                            listR={"+7 777 77 77"}
                        />
                    </div>
                </div>
                <div className={cl.uploadList}>
                    <div
                        className={cl.uploadArea}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                    >
                        {selectedFile ? (
                            <div className={cl.fileWrap}>
                                <div className={cl.fileInfo}>
                                    {selectedFile.name}
                                    <img src={delete_icon} onClick={handleRemoveFile} alt={"delete"}/>
                                </div>
                            </div>

                        ) : (
                            <label htmlFor="fileInput" className={cl.fileWrap}>
                                <input
                                    type="file"
                                    id="fileInput"
                                    accept=".xlsx" //TODO добавлять ли ограничение в формате
                                    hidden
                                    onChange={handleFileChange}
                                />
                                Choose .xlsx file / Drag .xlsx  file
                            </label>
                        )}
                    </div>
                    {selectedFile &&(
                        <button
                            onClick={async () => await uploadFile()}
                        >
                            Upload list
                        </button>
                    )}
                    {isInvalidFile &&(
                        <div className={cl.errorToast}>
                            <img src={error} alt={"error"}/>
                            Invalid file type
                        </div>
                    )}
                    <div className={cl.warningToast}>
                        <img src={warning} alt={"warning"}/>
                        Make sure that in your list there is no empty cells
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UploadModal;